import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d589d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userView" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { id: "userAcceptedQuestionDetail" }
const _hoisted_4 = { style: {"float":"left","width":"200px","height":"88px","background-color":"rgb(247, 248, 250)","border-radius":"10px"} }
const _hoisted_5 = { style: {"text-align":"center","font-size":"20px","margin-top":"15px"} }
const _hoisted_6 = { style: {"text-align":"center","font-size":"18px"} }
const _hoisted_7 = { style: {"float":"left","margin-left":"6px","width":"200px","height":"88px","background-color":"rgb(247, 248, 250)","border-radius":"10px"} }
const _hoisted_8 = { style: {"text-align":"center","font-size":"20px","margin-top":"15px"} }
const _hoisted_9 = { style: {"text-align":"center","font-size":"18px"} }
const _hoisted_10 = { style: {"float":"left","margin-left":"6px","width":"200px","height":"88px","background-color":"rgb(247, 248, 250)","border-radius":"10px"} }
const _hoisted_11 = { style: {"text-align":"center","font-size":"20px","margin-top":"15px"} }
const _hoisted_12 = { style: {"text-align":"center","font-size":"18px"} }
const _hoisted_13 = { style: {"float":"left","margin-left":"6px","width":"200px","height":"88px","background-color":"rgb(247, 248, 250)","border-radius":"10px"} }
const _hoisted_14 = { style: {"text-align":"center","font-size":"20px","margin-top":"15px"} }
const _hoisted_15 = { style: {"text-align":"center","font-size":"18px"} }
const _hoisted_16 = { id: "userSubmitDetail" }
const _hoisted_17 = { id: "other" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["src"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]

import { useStore } from "vuex";
import { onMounted, ref, watch, watchEffect } from "vue";
import { Message } from "@arco-design/web-vue";
import { useRouter } from "vue-router";
import {
  QuestionSolutionCollectControllerService,
  QuestionSolutionControllerService,
} from "../../../generated";
import { UserControllerService } from "../../../generated/services/UserControllerService";
import message from "@arco-design/web-vue/es/message";
import { FollowControllerService } from "../../../generated/services/FollowControllerService";
import { AcceptedQuestionDetailVO } from "../../../generated/models/AcceptedQuestionDetailVO";
import { AcceptedQuestionControllerService } from "../../../generated/services/AcceptedQuestionControllerService";
import { QuestionSubmitControllerService } from "../../../generated/services/QuestionSubmitControllerService";
import { QuestionListControllerService } from "../../../generated/services/QuestionListControllerService";
import { QuestionCollectControllerService } from "../../../generated/services/QuestionCollectControllerService";
import { QuestionControllerService } from "../../../generated/services/QuestionControllerService";
import { Question } from "../../../generated/models/Question";
import { QuestionListCollectControllerService } from "../../../generated/services/QuestionListCollectControllerService";

interface Props {
  id: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaView',
  props: {
    id: { default: () => "" }
  },
  setup(__props: any) {

document.title = "Ta的主页";

const router = useRouter();
const store = useStore();

// 获取登录用户
let loginUser = store.state.user.loginUser;

// 获取用户id
const props = __props;

const isFollow = ref(false);

// 获取用户
const user = ref({
  createTime: "",
  email: "",
  fans: 0,
  followers: 0,
  gender: 0,
  id: props.id,
  score: 0,
  updateTime: "",
  userAccount: "",
  userAvatar: "",
  userName: "",
  userProfile: "",
  userRole: "",
});

// 个人信息所展示的列
const userInfoColumns = [
  {
    label: "账号：",
    value: user.value.userAccount,
  },
  {
    label: "用户昵称：",
    value: user.value.userName,
  },
  {
    label: "我的简介：",
    value: user.value.userProfile,
  },

  {
    label: "邮箱：",
    value: user.value.email,
  },
];

// 通过题目排名
const acceptedQuestionRanking = ref(1);

// 题单分页
const questionList = ref([]);
const questionListTotal = ref(0);
const questionListSearchParams = ref({
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  title: "",
  userId: props.id,
});

// 具体的题单中的题目分页
const questions = ref([]);
const questionsTotal = ref(0);
const questionsSearchParams = ref({
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  questionListId: 0,
});

// 收藏题单分页
const collectQuestionList = ref([]);
const collectQuestionListTotal = ref(0);
const collectQuestionListSearchParams = ref({
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  userId: props.id,
});

// 具体的收藏题单中的题目分页
const collectQuestions = ref([]);
const collectQuestionsTotal = ref(0);
const collectQuestionsSearchParams = ref({
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  questionListId: 0,
});

// 用来记录所点击的某个题单的id
const questionListId = ref(0);

// 通过题目详情
const acceptedQuestionDetail = ref({
  passTotalNum: 0,
  eachDifficultyPassNum: {
    0: 0,
    1: 0,
    2: 0,
  },
  questionTotalNum: 0,
  eachDifficultyQuestionNum: {
    0: 0,
    1: 0,
    2: 0,
  },
  submissionPassRate: 0,
  eachDifficultysubmissionPassRate: {
    0: 0,
    1: 0,
    2: 0,
  },
} as AcceptedQuestionDetailVO);

// 题目提交详情
const submitDetail = ref({
  years: {},
  submitDetail: {},
  dayNum: {},
});

// 题目提交的年份
const years = ref([]);

// 题解
const questionSolutionList = ref([]);
const questionSolutionListTotal = ref(0);
const questionSolutionListSearchParams = ref({
  pageSize: 4,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  userId: props.id,
  questionId: null,
  title: "",
  tags: [],
});

// 题解收藏
const collectQuestionSolutionList = ref([]);
const collectQuestionSolutionListTotal = ref(0);
const collectQuestionSolutionListSearchParams = ref({
  pageSize: 4,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  userId: props.id,
  solutionId: null,
});

// 弹窗是否可见
const actualQuestionsVisible = ref(false);
const actualCollectQuestionsVisible = ref(false);
// 打开弹窗
const openActualQuestionsModal = (id: number) => {
  questionListId.value = id;
  actualQuestionsVisible.value = true;
  getQuestionsByQuestionListId(id);
};
const openActualCollectQuestionsModal = (id: number) => {
  actualCollectQuestionsVisible.value = true;
  getCollectQuestionsByCollectQuestionListId(id);
};
// 关闭弹窗
const closeActualQuestionsModel = () => {
  actualQuestionsVisible.value = false;
};
const closeActualCollectQuestionsModel = () => {
  actualCollectQuestionsVisible.value = false;
};

// 热力图
const hotMap = ref({
  tooltip: {
    position: "top",
    formatter: function (params) {
      return `${params.value}`;
    },
  },
  visualMap: {
    min: 0,
    max: 20,
    calculable: true,
    splitNumber: "5",
    type: "piecewise",
    orient: "horizontal",
    left: "center",
    top: "top",
    inRange: {
      color: ["#ebedf0", "#9be9a8", "#40c463", "#30a14e", "#216e39"],
    },
  },
  calendar: [
    {
      left: 30,
      right: 30,
      range: "",
      cellSize: ["auto", 16],
    },
  ],
  series: [
    {
      type: "heatmap",
      coordinateSystem: "calendar",
      calendarIndex: 0,
      data: [],
    },
  ],
});

/**
 * 获取个人通过题目数排名
 */
const getAcceptedQuestionRanking = async () => {
  const res =
    await AcceptedQuestionControllerService.getAcceptedQuestionRankingUsingGet(
      props.id
    );
  if (res.code == 0) {
    acceptedQuestionRanking.value = res.data as number;
  }
};

/**
 * 关注或取消关注
 * @param record
 */
const follow = async (userId: number, followOrNot: boolean) => {
  const res = await FollowControllerService.followUsingPost(
    followOrNot,
    userId
  );
  if (res.code === 0) {
    if (!followOrNot) {
      message.normal("取消关注成功(ง •̀_•́)ง");
    } else {
      message.normal("关注成功(ง •̀_•́)ง");
    }
    await getIsFollow();
  } else {
    message.error(res.message);
  }
};

/**
 * 改变页码
 * @param page
 */
const onQuestionListPageChange = (page: number) => {
  questionListSearchParams.value = {
    ...questionListSearchParams.value,
    current: page,
  };
};
const onQuestionsPageChange = (page: number) => {
  questionsSearchParams.value = {
    ...questionsSearchParams.value,
    current: page,
  };
};
const onCollectQuestionListPageChange = (page: number) => {
  collectQuestionListSearchParams.value = {
    ...collectQuestionListSearchParams.value,
    current: page,
  };
};
const onCollectQuestionsPageChange = (page: number) => {
  collectQuestionsSearchParams.value = {
    ...collectQuestionsSearchParams.value,
    current: page,
  };
};
const onQuestionSolutionListPageChange = (page: number) => {
  questionSolutionListSearchParams.value = {
    ...questionSolutionListSearchParams.value,
    current: page,
  };
  getQuestionSolutionList();
};
const onCollectQuestionSolutionListPageChange = (page: number) => {
  collectQuestionSolutionListSearchParams.value = {
    ...collectQuestionSolutionListSearchParams.value,
    current: page,
  };
  getCollectQuestionSolutionList();
};

/**
 * 改变分页大小
 * @param size
 */
const onQuestionListPageSizeChange = (size: number) => {
  questionListSearchParams.value = {
    ...questionListSearchParams.value,
    pageSize: size,
  };
};
const onQuestionsPageSizeChange = (size: number) => {
  questionsSearchParams.value = {
    ...questionsSearchParams.value,
    pageSize: size,
  };
};
const onCollectQuestionListPageSizeChange = (size: number) => {
  collectQuestionListSearchParams.value = {
    ...collectQuestionListSearchParams.value,
    pageSize: size,
  };
};
const onCollectQuestionsPageSizeChange = (size: number) => {
  collectQuestionsSearchParams.value = {
    ...collectQuestionsSearchParams.value,
    pageSize: size,
  };
};
const onQuestionSolutionListPageSizeChange = (size: number) => {
  questionSolutionListSearchParams.value = {
    ...questionSolutionListSearchParams.value,
    pageSize: size,
  };
  getQuestionSolutionList();
};
const onCollectQuestionSolutionListPageSizeChange = (size: number) => {
  collectQuestionSolutionListSearchParams.value = {
    ...collectQuestionSolutionListSearchParams.value,
    pageSize: size,
  };
  getCollectQuestionSolutionList();
};

/**
 * 获取用户信息
 */
const getUser = async () => {
  const res = await UserControllerService.getUserVoByIdUsingGet(
    props.id as any
  );
  if (res.code == 0) {
    user.value = res.data as any;
  } else {
    message.error("" + res.message);
  }
};

const getIsFollow = async () => {
  const res = await FollowControllerService.isFollowUsingGet(props.id as any);
  if (res.code == 0) {
    isFollow.value = res.data as any;
  } else {
    message.error("" + res.message);
  }
};

/**
 * 获取通过题目详情
 */
const getAcceptedQuestionDetail = async () => {
  const res =
    await AcceptedQuestionControllerService.getAcceptedQuestionDetailUsingGet(
      props.id as any
    );
  if (res.code === 0) {
    acceptedQuestionDetail.value = res.data as {};
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 获取个人提交详情
 */
const getSubmitDetail = async () => {
  const res =
    await QuestionSubmitControllerService.getPersonSubmitDetailUsingGet(
      props.id as any
    );
  if (res.code === 0) {
    console.log(submitDetail.value.submitDetail);
    submitDetail.value = res.data as any;
    hotMap.value.series[0].data = Object.entries(
      res.data?.submitDetail as any
    ) as any;
    years.value = Object.keys(res.data?.years as any) as never[];
    if (years.value.length == 0) {
      years.value = [new Date().getFullYear() as never];
    }
    hotMap.value.calendar[0].range = years.value.at(-1) as any;
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 获取题单
 */
const getQuestionList = async () => {
  const res =
    await QuestionListControllerService.listQuestionListByPageUserUsingPost(
      questionListSearchParams.value as any
    );
  if (res.code === 0) {
    questionList.value = res.data.records;
    questionListTotal.value = res.data.total;
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 获取某个题单的题目
 */
const getQuestionsByQuestionListId = async (id: number) => {
  console.log(questionsSearchParams.value);
  const res =
    await QuestionCollectControllerService.listQuestionCollectByPageUserUsingPost(
      { ...questionsSearchParams.value, questionListId: id }
    );
  if (res.code === 0) {
    questions.value = (await Promise.all(
      res.data.records.map(async (x: any) => {
        const questionVO =
          await QuestionControllerService.getQuestionVoByIdUsingGet(
            x.questionId
          );
        return { ...questionVO.data, questionListId: id };
      })
    )) as [];
    questionsTotal.value = res.data.total;
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 跳转到做题页面
 * @param question
 */
const toDoQuestion = (question: Question) => {
  router.push({
    path: `/view/question/${question.id}`,
  });
};

/**
 * 获取收藏的题单
 */
const getCollectQuestionList = async () => {
  const res =
    await QuestionListCollectControllerService.listQuestionListCollectByPageUserUsingPost(
      collectQuestionListSearchParams.value as any
    );
  if (res.code === 0) {
    collectQuestionList.value = (await Promise.all(
      res.data.records.map(async (x: any) => {
        const questionList =
          await QuestionListControllerService.getQuestionListByIdUsingPost(
            x.questionListId
          );
        return questionList.data;
      })
    )) as [];
    collectQuestionListTotal.value = res.data.total;
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 获取某个收藏题单的题目
 */
const getCollectQuestionsByCollectQuestionListId = async (id: number) => {
  const res =
    await QuestionCollectControllerService.listQuestionCollectByPageUserUsingPost(
      { ...collectQuestionsSearchParams.value, questionListId: id }
    );
  if (res.code === 0) {
    collectQuestions.value = (await Promise.all(
      res.data.records.map(async (x: any) => {
        const questionVO =
          await QuestionControllerService.getQuestionVoByIdUsingGet(
            x.questionId
          );
        return { ...questionVO.data, questionListId: id };
      })
    )) as [];
    collectQuestionsTotal.value = res.data.total;
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 获取题解
 */
const getQuestionSolutionList = async () => {
  const res =
    await QuestionSolutionControllerService.listQuestionSolutionByPageUserUsingPost(
      questionSolutionListSearchParams.value as any
    );
  if (res.code == 0) {
    questionSolutionList.value = res.data.records;
    questionSolutionListTotal.value = res.data.total;
  } else {
    message.error(res.message);
  }
};

/**
 * 获取收藏的题解
 */
const getCollectQuestionSolutionList = async () => {
  const res =
    await QuestionSolutionCollectControllerService.listQuestionSolutionCollectByPageUserUsingPost(
      collectQuestionSolutionListSearchParams.value as any
    );
  if (res.code === 0) {
    collectQuestionSolutionList.value = (await Promise.all(
      res.data.records.map(async (x: any) => {
        const questionSolution =
          await QuestionSolutionControllerService.getQuestionSolutionByIdUsingGet(
            x.solutionId
          );
        return questionSolution.data;
      })
    )) as [];
    collectQuestionSolutionListTotal.value = res.data.total;
  } else {
    Message.error("" + res.message);
  }
};

onMounted(async () => {
  await getIsFollow();
  await getUser();
  await getAcceptedQuestionDetail();
  await getAcceptedQuestionRanking();
  await getSubmitDetail();
  await getQuestionList();
  await getQuestionSolutionList();
  await getCollectQuestionSolutionList();
});

/**
 * 监听 searchParams 变量，改变时触发页面的重新加载
 */
watch(
  questionListSearchParams,
  () => {
    getQuestionList();
  },
  { deep: true }
);
watchEffect(() => {
  getQuestionsByQuestionListId(questionListId.value);
});
watchEffect(async () => {
  await getCollectQuestionList();
});
watch(
  questionSolutionListSearchParams.value,
  () => {
    getQuestionSolutionList();
  },
  { deep: true }
);

/**
 * 回到首页
 * @param question
 */
const toIndex = () => {
  router.push({
    path: `/`,
  });
};

/**
 * 点击题解进行跳转
 * @param questionSolutionId
 */
const goToSolution = (questionId: number, questionSolutionId: number) => {
  router.push({
    path: `/view/question/${questionId}/solution/${questionSolutionId}`,
  });
};

/**
 * 点击头像进行跳转
 * @param userId
 */
const goToUser = (userId: number) => {
  if (userId == loginUser.id) {
    router.push({
      path: `/mine`,
    });
  } else {
    router.push({
      path: `/Ta/${userId}`,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_icon_plus = _resolveComponent("icon-plus")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_icon_menu = _resolveComponent("icon-menu")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_typography = _resolveComponent("a-typography")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_overflow_list = _resolveComponent("a-overflow-list")!
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_IconMessage = _resolveComponent("IconMessage")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_descriptions_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            size: 100,
            shape: "circle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                alt: "头像",
                src: user.value.userAvatar
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          (!isFollow.value)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "text",
                shape: "round",
                status: "normal",
                size: "medium",
                style: {"margin":"10px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (follow(user.value.id, true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_plus),
                  _createTextVNode(" 关注 ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "text",
                shape: "round",
                status: "normal",
                size: "medium",
                style: {"margin":"10px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (follow(user.value.id, false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_menu),
                  _createTextVNode(" 已关注 ")
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, { title: "全站排名" }, {
        extra: _withCtx(() => [
          _createVNode(_component_a_tooltip, { content: "通过题目数排名" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_badge, {
                status: "processing",
                text: acceptedQuestionRanking.value
              }, null, 8, ["text"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_descriptions, {
            size: "large",
            column: "1",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, { label: '账号' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.userAccount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: '用户昵称' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.userName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: '我的简介' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.userProfile), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: '用户角色' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.userRole === "user" ? "普通用户" : "管理员"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: '邮箱' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.email), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: '性别' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(user.value.gender == null ? "未设置" : user.value.gender == 0 ? "男" : "女"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_a_button, {
          shape: "round",
          status: "success",
          size: "small",
          type: "outline",
          style: {"margin":"10px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_link, { onClick: toIndex }, {
              default: _withCtx(() => [
                _createTextVNode("首页")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_tooltip, {
        position: "bottom",
        content: 
        acceptedQuestionDetail.value.eachDifficultysubmissionPassRate[0].toFixed(2) * 100 + '%'
      
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_typography_text, { type: "success" }, {
                default: _withCtx(() => [
                  _createTextVNode(" 简单")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_typography_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(acceptedQuestionDetail.value.eachDifficultyPassNum[0]) + "/" + _toDisplayString(acceptedQuestionDetail.value.eachDifficultyQuestionNum[0]), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_a_tooltip, {
        position: "bottom",
        content: 
        acceptedQuestionDetail.value.eachDifficultysubmissionPassRate[1].toFixed(2) * 100 + '%'
      
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_typography_text, { type: "warning" }, {
                default: _withCtx(() => [
                  _createTextVNode(" 中等")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_a_typography_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(acceptedQuestionDetail.value.eachDifficultyPassNum[1]) + "/" + _toDisplayString(acceptedQuestionDetail.value.eachDifficultyQuestionNum[1]), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_a_tooltip, {
        position: "bottom",
        content: 
        acceptedQuestionDetail.value.eachDifficultysubmissionPassRate[2].toFixed(2) * 100 + '%'
      
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_typography_text, { type: "danger" }, {
                default: _withCtx(() => [
                  _createTextVNode(" 困难")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_typography_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(acceptedQuestionDetail.value.eachDifficultyPassNum[2]) + "/" + _toDisplayString(acceptedQuestionDetail.value.eachDifficultyQuestionNum[2]), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_a_tooltip, {
        position: "bottom",
        content: (acceptedQuestionDetail.value.submissionPassRate)?.toFixed(2) * 100 + '%'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_a_typography_text, { type: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" 已解答")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_a_typography_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(acceptedQuestionDetail.value.passTotalNum) + "/" + _toDisplayString(acceptedQuestionDetail.value.questionTotalNum), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            modelValue: hotMap.value.calendar[0].range,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hotMap.value.calendar[0].range) = $event)),
            style: { width: '150px' },
            placeholder: "请选择年份"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                return (_openBlock(), _createBlock(_component_a_option, { value: year }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(year), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_a_typography, { style: {"margin-left":"100px","color":"#3c3c4399"} }, {
            default: _withCtx(() => [
              _createTextVNode("总提交次数： ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(submitDetail.value.years[hotMap.value.calendar[0].range]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography, { style: {"margin-left":"100px","color":"#3c3c4399"} }, {
            default: _withCtx(() => [
              _createTextVNode("累计提交天数： ")
            ]),
            _: 1
          }),
          _createVNode(_component_a_typography, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(submitDetail.value.dayNum[hotMap.value.calendar[0].range]), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_chart, {
        autoresize: "",
        option: hotMap.value
      }, null, 8, ["option"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_a_tabs, {
        "default-active-key": "questionList",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "questionList",
            title: "题单"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: questionListSearchParams.value,
                layout: "inline",
                style: {"justify-content":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { field: "title" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_search, {
                        modelValue: questionListSearchParams.value.title,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((questionListSearchParams.value.title) = $event)),
                        placeholder: "搜索题单",
                        style: {"border-radius":"10px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_a_list, {
                scrollbar: true,
                "max-height": 700,
                size: 'large',
                data: questionList.value,
                "pagination-props": {
            total: questionListTotal.value,
            current: questionListSearchParams.value.current,
            pageSize: questionListSearchParams.value.pageSize,
            showTotal: true,
          },
                onPageSizeChange: onQuestionListPageSizeChange,
                onPageChange: onQuestionListPageChange
              }, {
                item: _withCtx(({ item }) => [
                  _createVNode(_component_a_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "text",
                        shape: "round",
                        status: "normal",
                        size: "medium",
                        style: {"margin":"10px"},
                        onClick: ($event: any) => (openActualQuestionsModal(item.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_list_item_meta, {
                            title: item.title
                          }, null, 8, ["title"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["data", "pagination-props"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "questionSolution",
            title: "题解"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: questionSolutionListSearchParams.value,
                layout: "inline",
                style: {"justify-content":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { field: "tags" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_tag, {
                        modelValue: questionSolutionListSearchParams.value.tags,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((questionSolutionListSearchParams.value.tags) = $event)),
                        placeholder: "输入标签",
                        style: {"width":"200px","border-radius":"10px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { field: "title" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_search, {
                        modelValue: questionSolutionListSearchParams.value.title,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((questionSolutionListSearchParams.value.title) = $event)),
                        placeholder: "搜索题解",
                        style: {"width":"200px","border-radius":"10px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createVNode(_component_a_list, {
                hoverable: true,
                scrollbar: true,
                "max-height": 700,
                size: 'large',
                data: questionSolutionList.value,
                "pagination-props": {
            total: questionSolutionListTotal.value,
            current: questionSolutionListSearchParams.value.current,
            pageSize: questionSolutionListSearchParams.value.pageSize,
            showTotal: true,
          },
                onPageSizeChange: onQuestionSolutionListPageSizeChange,
                onPageChange: onQuestionSolutionListPageChange
              }, {
                item: _withCtx(({ item }) => [
                  _createVNode(_component_a_list_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_list_item_meta, {
                        title: item.title
                      }, {
                        avatar: _withCtx(() => [
                          _createVNode(_component_a_avatar, null, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                alt: "avatar",
                                src: item.userAvatar
                              }, null, 8, _hoisted_18)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        title: _withCtx(() => [
                          _createVNode(_component_a_typography_text, {
                            bold: "",
                            onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        description: _withCtx(() => [
                          _createVNode(_component_a_typography_text, {
                            ellipsis: "",
                            type: "secondary",
                            onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.content), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_overflow_list, {
                            style: {"width":"500px"},
                            min: "8",
                            margin: "8",
                            onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.tags), (tag, index) => {
                                return (_openBlock(), _createBlock(_component_a_tag, {
                                  key: index,
                                  color: "gray",
                                  style: {"border-radius":"10px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createElementVNode("span", {
                            onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                          }, [
                            _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } }),
                            _createTextVNode(" " + _toDisplayString(item.likes), 1)
                          ], 8, _hoisted_19),
                          _createElementVNode("span", {
                            style: {"margin-left":"5px"},
                            onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                          }, [
                            _createVNode(_component_IconMessage),
                            _createTextVNode(" " + _toDisplayString(item.comments), 1)
                          ], 8, _hoisted_20)
                        ]),
                        _: 2
                      }, 1032, ["title"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["data", "pagination-props"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "collect",
            title: "收藏"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                position: 'left',
                "default-active-key": "collectQuestionList",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "collectQuestionList",
                    title: "题单"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_list, {
                        scrollbar: true,
                        "max-height": 700,
                        size: 'large',
                        data: collectQuestionList.value,
                        "pagination-props": {
                total: collectQuestionListTotal.value,
                current: collectQuestionListSearchParams.value.current,
                pageSize: collectQuestionListSearchParams.value.pageSize,
                showTotal: true,
              },
                        onPageSizeChange: onCollectQuestionListPageSizeChange,
                        onPageChange: onCollectQuestionListPageChange
                      }, {
                        item: _withCtx(({ item }) => [
                          _createVNode(_component_a_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "text",
                                shape: "round",
                                status: "normal",
                                size: "medium",
                                style: {"margin":"10px"},
                                onClick: ($event: any) => (openActualCollectQuestionsModal(item.id))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_list_item_meta, {
                                    title: item.title
                                  }, null, 8, ["title"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 8, ["data", "pagination-props"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "collectQuestionSolution",
                    title: "题解"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_list, {
                        hoverable: true,
                        scrollbar: true,
                        "max-height": 700,
                        size: 'large',
                        data: collectQuestionSolutionList.value,
                        "pagination-props": {
                total: collectQuestionSolutionListTotal.value,
                current: collectQuestionSolutionListSearchParams.value.current,
                pageSize: collectQuestionSolutionListSearchParams.value.pageSize,
                showTotal: true,
              },
                        onPageSizeChange: onCollectQuestionSolutionListPageSizeChange,
                        onPageChange: onCollectQuestionSolutionListPageChange
                      }, {
                        item: _withCtx(({ item }) => [
                          _createVNode(_component_a_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_list_item_meta, {
                                title: item.title
                              }, {
                                avatar: _withCtx(() => [
                                  _createVNode(_component_a_avatar, {
                                    onClick: ($event: any) => (goToUser(item.userId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        alt: "avatar",
                                        src: item.userAvatar
                                      }, null, 8, _hoisted_21)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                title: _withCtx(() => [
                                  _createVNode(_component_a_typography_text, {
                                    bold: "",
                                    onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                description: _withCtx(() => [
                                  _createVNode(_component_a_typography_text, {
                                    ellipsis: "",
                                    type: "secondary",
                                    onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.content), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_overflow_list, {
                                    style: {"width":"500px"},
                                    min: "4",
                                    margin: "8",
                                    onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(item.tags), (tag, index) => {
                                        return (_openBlock(), _createBlock(_component_a_tag, {
                                          key: index,
                                          color: "gray",
                                          style: {"border-radius":"10px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(tag), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createElementVNode("span", {
                                    onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                                  }, [
                                    _createVNode(_component_IconHeartFill, { style: { color: '#f53f3f' } }),
                                    _createTextVNode(" " + _toDisplayString(item.likes), 1)
                                  ], 8, _hoisted_22),
                                  _createElementVNode("span", {
                                    style: {"margin-left":"5px"},
                                    onClick: ($event: any) => (goToSolution(item.questionId, item.id))
                                  }, [
                                    _createVNode(_component_IconMessage),
                                    _createTextVNode(" " + _toDisplayString(item.comments), 1)
                                  ], 8, _hoisted_23)
                                ]),
                                _: 2
                              }, 1032, ["title"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 8, ["data", "pagination-props"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      width: "50%",
      visible: actualQuestionsVisible.value,
      placement: "right",
      onCancel: closeActualQuestionsModel,
      unmountOnClose: "",
      footer: false,
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_list, {
          data: questions.value,
          "pagination-props": {
        total: questionsTotal.value,
        current: questionsSearchParams.value.current,
        pageSize: questionsSearchParams.value.pageSize,
        showTotal: true,
        showPageSize: true,
      },
          onPageSizeChange: onQuestionsPageSizeChange,
          onPageChange: onQuestionsPageChange
        }, {
          item: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: "round",
                  status: "normal",
                  size: "medium",
                  style: {"margin":"10px"},
                  onClick: ($event: any) => (toDoQuestion(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_list_item_meta, {
                      title: item.title
                    }, null, 8, ["title"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination-props"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      width: "50%",
      visible: actualCollectQuestionsVisible.value,
      placement: "right",
      onCancel: closeActualCollectQuestionsModel,
      unmountOnClose: "",
      footer: false,
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_list, {
          data: collectQuestions.value,
          "pagination-props": {
        total: collectQuestionsTotal.value,
        current: collectQuestionsSearchParams.value.current,
        pageSize: collectQuestionsSearchParams.value.pageSize,
        showTotal: true,
        showPageSize: true,
      },
          onPageSizeChange: onCollectQuestionsPageSizeChange,
          onPageChange: onCollectQuestionsPageChange
        }, {
          item: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: "round",
                  status: "normal",
                  size: "medium",
                  style: {"margin":"10px"},
                  onClick: ($event: any) => (toDoQuestion(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_list_item_meta, {
                      title: item.title
                    }, null, 8, ["title"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination-props"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})